export const SPECIALISTS_COUNT_PER_PAGE = 10;
